import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/_components/Carousel/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ImageSkeleton"] */ "/app/src/app/_components/Skeleton/ImageSkeleton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/_custom/item/components/Loading.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/_custom/item/styles/Slide.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/_home/components/Loading.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/products/[slug]/components/components/ItemCard.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/products/[slug]/components/Content.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/products/[slug]/components/styles/RelatedProducts.module.css");
